import React from 'react';
import PropTypes from 'prop-types';
import { Whisper, Tooltip, Icon } from 'rsuite';
import { get, getOr } from 'lodash/fp';
import { InventorySnapshotType } from '../../../interfaces/reservation';

const OrderItemName = ({ itemName, inventorySnapshot }) => {
  const zoneName = getOr('', 'zone.name', inventorySnapshot);
  return (
    <div>
      {inventorySnapshot && (
        <Whisper
          placement="left"
          trigger="hover"
          speaker={
            <Tooltip>
              {get('location.name', inventorySnapshot)}
              {zoneName && `, ${zoneName}`}
            </Tooltip>
          }
        >
          <Icon icon="info" style={{ color: '#87cce7', marginRight: 5 }} />
        </Whisper>
      )}
      {itemName}
    </div>
  );
};

OrderItemName.propTypes = {
  itemName: PropTypes.string.isRequired,
  inventorySnapshot: InventorySnapshotType
};

OrderItemName.defaultProps = {
  inventorySnapshot: {}
};

export default OrderItemName;
